import PromoPreview from 'components/PromoPreview';
import { BulletpointsProductModel, ExtraLinksProductModel, InfotextProductModel, LogoProductModel, WebshopId, WebshopProductModel, WebshopProducts } from 'models/WebShop';
import BreadcrumbCompany from 'pages/Account/BreadcrumbCompany';
import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from 'react-use-cart';
import { cloudinaryService, webShopService } from 'services/Services';
import { fromBase64, generateCloudinaryImageUrl } from 'utility/ImgUtilities';
import { isBulletpointsProduct, isExtraLinksProduct, isInfotextProduct, isLogoProduct } from 'utility/ProductUtility';
import { UrlPath } from 'utility/routes';

type ShoppingCartProps = {
  companyId: string;
  appliedCode: string;
  setAppliedCode: React.Dispatch<React.SetStateAction<string>>
};

const ShoppingCart = ({ companyId, appliedCode, setAppliedCode }: ShoppingCartProps) => {

  const cart = useCart();
  const [products, setProducts] = useState<WebshopProductModel[]>([]);
  const [initialProducts, setInitialProducts] = useState<WebshopProductModel[]>([]);
  const [couponCode, setCouponCode] = useState("");



  useEffect(() => {
    var getProducts = async () => {
      const fetchedProducts = await webShopService.getProducts();
      if (fetchedProducts !== undefined) {
        setProducts(fetchedProducts);
        setInitialProducts(fetchedProducts);
      }

    }
    getProducts();

  }, []);

  const handleDelete = (id: string) => {
    cart.removeItem(id);
    handleCloseModal(id);
  };

  const fetchProductsWithNewPrices = () => {


    try {

      const applyCoupon = async () => {
        const response = await webShopService.applyCoupon(couponCode);
        if (response !== undefined && response?.success) {
          setProducts(response.productDefinitions);
          setAppliedCode(couponCode);
        }
      }
      applyCoupon();
    }
    catch {

    }
  }

  const handleCloseModal = (id: string) => {
    const modalElement = document.getElementById(`ModalDeleteCartItem${id}`);
    if (modalElement) {
      const bootstrap = (window as any).bootstrap;
      const modalInstance = bootstrap.Modal.getInstance(modalElement) || new bootstrap.Modal(modalElement);
      modalInstance.hide();
    }

    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) backdrop.remove();

    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  };

  const filteredItems = cart.items.filter(p => p.documentId === companyId);

  const updatedItems = filteredItems.map(item => {
    const product = products.find(p => p.webShopProductId === item.webShopProductId);
    const initProduct = initialProducts.find(p => p.webShopProductId === item.webShopProductId);

    let price = item.price;
    let initPrice = item.price

    if (product && initProduct) {
      price = product.price;
      initPrice = initProduct.price
    }

    return {
      ...item,
      ...(product ?? {}),
      price,
      initPrice
    };
  });



  const logoProduct = filteredItems.find(x => isLogoProduct(x as WebshopProductModel)) as LogoProductModel
  const bulletPointsProduct = filteredItems.find(x => isBulletpointsProduct(x as WebshopProductModel)) as BulletpointsProductModel
  const extraLinksProduct = filteredItems.find(x => isExtraLinksProduct(x as WebshopProductModel)) as ExtraLinksProductModel
  const infoTextProduct = filteredItems.find(x => isInfotextProduct(x as WebshopProductModel)) as InfotextProductModel


  const [logoPreviewArg, setLogoPreviewArg] = useState<string>("");

  useEffect(() => {
    const fetchLogoUrl = async () => {
      if (logoProduct?.img) {
        const base64 = fromBase64(logoProduct.img, "placeholder.png");
        const url = await generateCloudinaryImageUrl(base64);
        setLogoPreviewArg(url ?? "");
      }
    };
    fetchLogoUrl();
  }, []);

  const infotextPreviewArg = useMemo(() => infoTextProduct?.infotext ?? "", [infoTextProduct]);

  const bulletPointsPreviewArg = useMemo(() => {
    return bulletPointsProduct?.bulletpoints.filter(x => x !== "").toString() ?? "";
  }, [bulletPointsProduct]);

  const extraLinksPreviewArg = useMemo(() => {
    return extraLinksProduct?.extraLinks
      .filter(link => link.label && link.url)
      .map(link => `${link.label}¤${link.url}`)
      .join(",") ?? "";
  }, [extraLinksProduct]);




  return (
    <>
      <>
        <h1 className="h3">Handlekurv</h1>
        <p className="text-muted">
          Alle varer fornyes automatisk tre måneder før endt periode. Kontakt <a href="https://kundeservice.1881.no">kundeservice</a> dersom du ikke ønsker automatisk fornyelse. Ordren vil bli behandlet fortløpende før det vises på nett.
        </p>
        <PromoPreview id={companyId} logo={logoPreviewArg} infoText={infotextPreviewArg} bulletpoints={bulletPointsPreviewArg} extraLinks={extraLinksPreviewArg} />
        <div className="cc-scroll-wrapper">
          <div className="table-responsive cc-scroll-container">
            <table className="table cc-table cc-table-shoppingcart cc-table-muted mb-4">
              <tbody>
                <tr>
                  <th>Produkt</th>
                  <th>Periode</th>
                  <th style={{ width: '120px' }} >Pris</th>
                  <th></th>
                </tr>
                {updatedItems.map((p, index) => (

                  <tr className="cc-cart-item" id={`cartItem${p.id}`} key={p.id}>
                    <td>
                      <Link to={`${UrlPath.Account.WebShopBase}/${companyId}/${p.path}`}>{p.name}</Link>
                    </td>
                    <td>{new Date().toLocaleDateString('nb-NO')} - {new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toLocaleDateString('nb-NO')} </td>
                    <td>
                      {p.price === p.basePrice ? (
                        `${p.price},-`
                      ) : (
                        <>
                          <span style={{ textDecoration: 'line-through', marginRight: '8px', color:"rgba(33, 37, 41, 0.75)" }}>
                            {p.basePrice},-
                          </span>
                          {p.price},-
                        </>
                      )}
                    </td>




                    <td>
                      <span
                        className="cc-shop-delete-item"
                        role="button"
                        data-bs-toggle="modal"
                        data-bs-target={`#ModalDeleteCartItem${p.id}`}
                      >
                        <i className="bi bi-trash3">
                          <span className="visually-hidden">Slett</span>
                        </i>
                      </span>
                    </td>
                  </tr>
                ))}
                {appliedCode &&
                  <tr className="cc-cart-item" id={`cartItemdiscount`} key={`cartItemdiscount`}>
                    <td>Rabatt</td>
                    <td></td>
                    <td>{updatedItems.reduce((acc, p) => acc + p.price, 0) - updatedItems.reduce((acc, p) => acc + p.initPrice, 0)},-</td>
                    <td></td>
                  </tr>

                }

                <tr className="cc-cart-total">
                  <td colSpan={2}><span className="cc-fw-medium">Totalt</span></td>
                  <td colSpan={2}>
                    <span className="cc-fw-medium">
                      {updatedItems.reduce((acc, p) => acc + p.price, 0)},-
                    </span>
                  </td>
                </tr>

                {updatedItems.length === 0 && (
                  <tr className="cc-cart-empty">
                    <td colSpan={4}>
                      Handlekurven er tom.{' '}
                      <Link to={`${UrlPath.Account.WebShopBase}/${companyId}`} className="d-inline-block">
                        Fortsett å handle
                      </Link>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="row mb-3">
          <label htmlFor="Rabattkode" className="col-sm-2 col-form-label">Rabattkode</label>
          <div className="col-sm-5">
            <div className="input-group">
              <input type="text" className="form-control" placeholder="Rabattkode" id="Rabattkode" value={couponCode} onChange={(e) => { setCouponCode(e.target.value.toLocaleUpperCase()) }} />
              <button className="btn btn-outline-secondary" type="button" style={{ borderColor: "rgb(222, 226, 230)" }} onClick={(e) => { e.preventDefault(); fetchProductsWithNewPrices() }}>Bruk</button>
            </div>
          </div>
        </div>
        <div>
        </div>
      </>

      {updatedItems.map((p, index) => (
        <div
          className="modal fade"
          id={`ModalDeleteCartItem${p.id}`}
          tabIndex={-1}
          aria-hidden="true"
          key={`modal-${p.id}`}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5">Fjern fra handlekurven</h1>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Lukk"></button>
              </div>
              <div className="modal-body">
                <p>Ønsker du å fjerne <strong>{p.name}</strong>?</p>
                <p>Lagret informasjon slettes.</p>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" data-bs-dismiss="modal">Avbryt</button>
                <button
                  onClick={(e) => { e.preventDefault(); handleDelete(p.id) }}
                  className="btn btn-primary"
                  data-bs-dismiss="modal"
                >
                  Fjern
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default ShoppingCart;
